
import { WorldCity } from '../types';

// Expansión de India - añadiendo 50 ciudades más
export const indiaAdditionalCities: WorldCity[] = [
  { name: 'Kurnool', slug: 'kurnool', population: 484327 },
  { name: 'Muzaffarpur', slug: 'muzaffarpur', population: 393724 },
  { name: 'Ahmednagar', slug: 'ahmednagar', population: 350905 },
  { name: 'Mathura', slug: 'mathura', population: 441894 },
  { name: 'Kollam', slug: 'kollam', population: 397419 },
  { name: 'Avadi', slug: 'avadi', population: 345996 },
  { name: 'Kadapa', slug: 'kadapa', population: 344893 },
  { name: 'Kamarhati', slug: 'kamarhati', population: 314088 },
  { name: 'Bilaspur', slug: 'bilaspur', population: 365579 },
  { name: 'Shahjahanpur', slug: 'shahjahanpur', population: 349816 },
  { name: 'Satara', slug: 'satara', population: 120000 },
  { name: 'Bijapur', slug: 'bijapur', population: 327427 },
  { name: 'Rampur', slug: 'rampur', population: 325248 },
  { name: 'Shivamogga', slug: 'shivamogga', population: 322650 },
  { name: 'Chandrapur', slug: 'chandrapur', population: 321036 },
  { name: 'Junagadh', slug: 'junagadh', population: 319462 },
  { name: 'Thrissur', slug: 'thrissur', population: 315596 },
  { name: 'Alwar', slug: 'alwar', population: 315310 },
  { name: 'Bardhaman', slug: 'bardhaman', population: 314638 },
  { name: 'Kulti', slug: 'kulti', population: 313809 },
  { name: 'Kakinada', slug: 'kakinada', population: 312538 },
  { name: 'Nizamabad', slug: 'nizamabad', population: 311152 },
  { name: 'Parbhani', slug: 'parbhani', population: 307170 },
  { name: 'Tumkur', slug: 'tumkur', population: 305821 },
  { name: 'Khammam', slug: 'khammam', population: 302975 },
  { name: 'Ozhukarai', slug: 'ozhukarai', population: 301367 },
  { name: 'Bihar Sharif', slug: 'bihar-sharif', population: 297268 },
  { name: 'Panipat', slug: 'panipat', population: 294132 },
  { name: 'Darbhanga', slug: 'darbhanga', population: 293195 },
  { name: 'Bally', slug: 'bally', population: 290141 },
  { name: 'Aizawl', slug: 'aizawl', population: 289571 },
  { name: 'Dewas', slug: 'dewas', population: 289550 },
  { name: 'Ichalkaranji', slug: 'ichalkaranji', population: 287570 },
  { name: 'Karnal', slug: 'karnal', population: 286367 },
  { name: 'Bathinda', slug: 'bathinda', population: 285813 },
  { name: 'Jalna', slug: 'jalna', population: 285348 },
  { name: 'Eluru', slug: 'eluru', population: 283648 },
  { name: 'Kirari Suleman Nagar', slug: 'kirari-suleman-nagar', population: 283004 },
  { name: 'Barabanki', slug: 'barabanki', population: 279065 },
  { name: 'Siliguri', slug: 'siliguri', population: 279000 },
  { name: 'Jhansi', slug: 'jhansi', population: 507293 },
  { name: 'Tirunelveli', slug: 'tirunelveli', population: 474838 },
  { name: 'Kota', slug: 'kota', population: 1001365 },
  { name: 'Ghaziabad', slug: 'ghaziabad', population: 2358525 },
  { name: 'Thane', slug: 'thane', population: 1841128 },
  { name: 'Amritsar', slug: 'amritsar', population: 1183705 },
  { name: 'Aligarh', slug: 'aligarh', population: 1025000 },
  { name: 'Guwahati', slug: 'guwahati', population: 963429 },
  { name: 'Chandigarh', slug: 'chandigarh', population: 1055450 },
  { name: 'Solapur', slug: 'solapur', population: 951558 }
];
